import src from "IMAGE";
export default { src, width: 600, height: 218, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAIAAAAhqtkfAAAAS0lEQVR42lXEOwqAMAwA0N7/AIKIR5Hi4CTZUvKdDIibm5vVrn3DS3pt93PW+n69tNqcbSy+I6Kqujszt9OiQ7bJj0JEItIGgIj4AW+GPnmoRr07AAAAAElFTkSuQmCC"};
